import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

export type WorkflowStepStats = {
  Interruptions: WorkflowStepInterruption[];
  StepId: number;
  TimesEntered: number;
  TimesErrored: number;
};

export type WorkflowStepInterruption = {
  Reason: string;
  TimesOccurred: number;
};

type WorkflowExecutionStatsRequest = {
  MarketingCampaignId: number;
  SinceDate: string;
};

export function useGetWorkflowExecutionStats(marketingCampaignId: number | null, since: Date | null) {
  const sinceDate = useMemo(() => {
    let sinceDate = since;
    if (!sinceDate) {
      sinceDate = new Date(Date.now() - 1000 * 60 * 60 * 24 * 365 * 20); // 20 years ago
    }
    sinceDate.setUTCHours(0, 0, 0, 0);
    return sinceDate;
  }, [since]);

  return useQuery({
    queryKey: ['workflow-execution-stats', marketingCampaignId, since],
    enabled: !!marketingCampaignId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      if (!marketingCampaignId) {
        return [];
      }

      return postData<WorkflowExecutionStatsRequest, WorkflowStepStats[]>({
        endpoint: 'api/marketing-campaign/get-workflow-campaign-execution-stats',
        payload: { MarketingCampaignId: marketingCampaignId, SinceDate: sinceDate.toISOString() },
      });
    },
  });
}
